module.exports = __webpack_public_path__ + "static/media/export-laptop-with-rockerbox-ui.1a27f826.png";